module.exports = __webpack_public_path__ + "img/2024-10-16c_1.85817e33.jpg";